import { ChecklistItemRecord } from "models/view-models/block-configurations/checklist-item-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface ChecklistBlockConfigurationChecklistItemsPathParams {
    configurationId: number;
}

export interface ChecklistBlockConfigurationChecklistItemsQueryParams {}

const resourceEndpoint: string =
    "blocks/configurations/checklist/:configurationId/checklistItems";

const resourceType = ChecklistItemRecord;

const ChecklistBlockConfigurationChecklistItemService = {
    useNestedList: ServiceHookFactory.useNestedList<
        ChecklistItemRecord,
        ChecklistBlockConfigurationChecklistItemsPathParams,
        ChecklistBlockConfigurationChecklistItemsQueryParams
    >(resourceType, resourceEndpoint),
};

export default ChecklistBlockConfigurationChecklistItemService;
